import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureVisibility } from '@selfCareShared/models/common.models';
import { SharedDataService } from '@selfCareShared/services/shared-data.service';

function isNotExplicitlyFalse(config: Partial<FeatureVisibility> | undefined, key: keyof FeatureVisibility): boolean {
  return config?.[key] !== false;
}

/**
 * Route `data`:
 * - `requireFeature`: single `FeatureVisibility` key — allowed unless that flag is explicitly `false` (matches `?? true` in templates).
 * - `requireAnyFeature`: array of keys — allowed if at least one key is not explicitly `false`.
 */
export const featureVisibilityGuard: CanActivateFn = (route) => {
  const sharedData = inject(SharedDataService);
  const router = inject(Router);
  const config = sharedData.featureVisibility();

  const single = route.data['requireFeature'] as keyof FeatureVisibility | undefined;
  if (single) {
    return isNotExplicitlyFalse(config, single) ? true : router.createUrlTree(['/dashboard']);
  }

  const anyKeys = route.data['requireAnyFeature'] as (keyof FeatureVisibility)[] | undefined;
  if (anyKeys?.length) {
    const allowed = anyKeys.some((key) => isNotExplicitlyFalse(config, key));
    return allowed ? true : router.createUrlTree(['/dashboard']);
  }

  return true;
};
